import { useParams } from 'react-router-dom';

export function MonitorDetailsPage() {
  const { id } = useParams();

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white shadow rounded-lg p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Monitor Details</h1>
        <p className="text-gray-600">Monitor ID: {id}</p>
      </div>
    </div>
  );
}
